import {
  WorkflowNodeData,
  WorkflowNodeTypes,
  SettingParamTypes,
} from "@/types/node";
import {Node} from "@xyflow/react";

export const endNodeBlueprint: Partial<Node<WorkflowNodeData>> = {
  type: WorkflowNodeTypes.END,
  data: {
    type: WorkflowNodeTypes.END,
    settingsTitle: "End Call",
    description: "This is the end node",
    onChange: () => {
      console.log("Start node changed");
    },
    settings: [
      {
        title: "General",
        description:
          "Provide your Assistant with a script to follow for this node, specifying what should be said to the recipient.",
        params: [
          {
            label: "Instructions",
            placeholder: "Thanks for calling. Have a great day!",
            type: SettingParamTypes.PROMPT,
            key: "instructions",
            value: "",
          },
        ],
      },
    ],
  },
  position: {x: 0, y: 0},
};
